import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, mergeProps as _mergeProps, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "fixed inset-0 z-50 flex justify-center bg-black/60" }
const _hoisted_2 = { class: "p-0 bg-gray-50 shadow-xl border border-gray-200 rounded-md text-center" }
const _hoisted_3 = { class: "flex flex-col w-full text-black" }
const _hoisted_4 = {
  key: 0,
  class: "absolute inset-0 flex items-center justify-center z-50 bg-black/20"
}
const _hoisted_5 = { class: "flex flex-col w-full rounded-t-md p-3 bg-gradient-to-r from-[#424c42] to-[#647064]" }
const _hoisted_6 = { class: "font-semibold text-white text-sm md:text-2xl truncate whitespace-nowrap overflow-hidden text-ellipsis" }
const _hoisted_7 = { class: "container p-4 text-left space-y-3" }
const _hoisted_8 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0" }
const _hoisted_9 = { class: "w-full px-2 md:w-1/1" }
const _hoisted_10 = { class: "block mb-1" }
const _hoisted_11 = { class: "text-sm text-red-500 p-error" }
const _hoisted_12 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0" }
const _hoisted_13 = { class: "w-full px-2 md:w-1/1" }
const _hoisted_14 = { class: "block mb-1" }
const _hoisted_15 = { class: "text-sm text-red-500 p-error" }
const _hoisted_16 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0" }
const _hoisted_17 = { class: "w-full px-2 md:w-1/1" }
const _hoisted_18 = { class: "block mb-1" }
const _hoisted_19 = { class: "text-sm text-red-500 p-error" }
const _hoisted_20 = { class: "p-3 flex flex-col md:flex-row gap-2 justify-end w-full mt-2 bg-gray-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Form = _resolveComponent("Form")!
  const _component_BlockUI = _resolveComponent("BlockUI")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "m-5 w-full md:w-8/12 lg:w-4/12 xl:w-3/12",
        onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.closeDialog(false)), ["self"]))
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_BlockUI, { visible: _ctx.blocked }, {
              default: _withCtx(() => [
                (_ctx.blocked)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createVNode(_component_ProgressSpinner, {
                        style: {"width":"50px","height":"50px"},
                        strokeWidth: "5",
                        fill: "transparent",
                        animationDuration: ".5s"
                      })
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", null, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: ['fas', 'fa-lock'],
                      class: "w-6 h-6 text-white"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('titulo.cambiar.password')), 1)
                ]),
                _createVNode(_component_Form, {
                  "validation-schema": _ctx.schema,
                  onInvalidSubmit: _ctx.onInvalidSubmit
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('label.contrasenia.actual')), 1),
                          _createVNode(_component_Field, {
                            name: "claveActual",
                            modelValue: _ctx.claveActual,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.claveActual) = $event))
                          }, {
                            default: _withCtx(({ field, errors }) => [
                              _createVNode(_component_InputText, _mergeProps(field, {
                                type: "password",
                                class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}]
                              }), null, 16, ["class"]),
                              _createElementVNode("span", _hoisted_11, [
                                _createVNode(_component_ErrorMessage, { name: "claveActual" })
                              ])
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('label.contrasenia.nueva')), 1),
                          _createVNode(_component_Field, {
                            name: "claveNueva",
                            modelValue: _ctx.claveNueva,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.claveNueva) = $event))
                          }, {
                            default: _withCtx(({ field, errors }) => [
                              _createVNode(_component_InputText, _mergeProps(field, {
                                type: "password",
                                class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}]
                              }), null, 16, ["class"]),
                              _createElementVNode("span", _hoisted_15, [
                                _createVNode(_component_ErrorMessage, { name: "claveNueva" })
                              ])
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('label.repetir.contrasenia')), 1),
                          _createVNode(_component_Field, {
                            name: "claveRepetida",
                            modelValue: _ctx.claveRepetida,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.claveRepetida) = $event))
                          }, {
                            default: _withCtx(({ field, errors }) => [
                              _createVNode(_component_InputText, _mergeProps(field, {
                                type: "password",
                                class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}]
                              }), null, 16, ["class"]),
                              _createElementVNode("span", _hoisted_19, [
                                _createVNode(_component_ErrorMessage, { name: "claveRepetida" })
                              ])
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["validation-schema", "onInvalidSubmit"]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("a", {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.closeDialog(false))),
                    class: "cursor-pointer px-6 text-sm font-bold text-red-500 bg-transparent py-3 border border-red-500 shadow-md rounded-xl transform transition-transform duration-200 hover:scale-105 active:scale-95"
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'fa-xmark'] }),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('boton.cancelar')), 1)
                  ]),
                  _createElementVNode("a", {
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.aplicarCambios && _ctx.aplicarCambios(...args))),
                    class: "cursor-pointer px-6 text-sm font-bold text-[#424c42] bg-transparent py-3 border border-[#424c42] shadow-md rounded-xl transform transition-transform duration-200 hover:scale-105 active:scale-95"
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: ['fas', 'fa-check-double'] }),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('boton.aceptar')), 1)
                  ])
                ])
              ]),
              _: 1
            }, 8, ["visible"])
          ])
        ])
      ])
    ])
  ]))
}